const previousActionStatusOfLicense = {
    NEW: {
        id: 677,
        status: "New",
    },
    UPDATD: {
        id: 678,
        status: "Updated",
    },
    SUPSPANDED: {
        id: 679,
        status: "Suspended",
    },
    RESUMED: {
        id: 680,
        status: "Resumed",
    },
    DEACTIVATED: {
        id: 681,
        status: "De-activated",
    },
    RENEWED: {
        id: 682,
        status: "Renewed",
    },
    LICENSE_TYPE_CHANGED: {
        id: 683,
        status: "LicenseTypeChanged",
    },
};


export default previousActionStatusOfLicense;